import type { ServiceCategory } from "@/lib/services";

// TODO(compliance): Confirm CRS is a registered approved installer under the Green Homes Plan
// and is permitted to use the scheme name/logo before publishing. Ensure wording is not
// confused with the former UK government "Green Homes Grant" voucher scheme.

export const GRANTS_PATH = "/grants" as const;

export const GRANTS_HERO = {
  eyebrow: "Green Homes Plan, Approved Installer",
  title: "Approved Installer For Funded Retrofit Work",
  subtitle:
    "We're an approved installer under the Green Homes Plan. If your home has had a retrofit assessment and qualifies, we carry out the installation work to standard, across Wales and the South West.",
} as const;

export const GRANTS_BADGES = [
  "Approved Installer",
  "MCS Certified",
  "TrustMark Registered",
  "Insurance-Backed",
] as const;

export const GRANTS_CLARITY = {
  install: {
    title: "We Install",
    body: "We carry out approved retrofit measures to standard under the Green Homes Plan, and document the work on completion.",
  },
  noAssess: {
    title: "We Don't Assess Or Fund",
    body: "Whether you qualify and what is funded is determined by the scheme and your retrofit assessment, not by us.",
  },
} as const;

export const GRANTS_SCHEME_STATUS = {
  title: "ECO4 And GBIS Have Closed",
  body: "The ECO4 and Great British Insulation Scheme (GBIS) grant schemes have now closed. We're no longer assisting with grant eligibility or applications. If you already have a retrofit assessment, we can carry out the installation under the Green Homes Plan.",
} as const;

export const GRANTS_PROCESS_STEPS = [
  {
    title: "You Have A Retrofit Assessment",
    body: "Carried out by a qualified retrofit assessor.",
  },
  {
    title: "Send Us Your Assessment Report",
    body: "So we can see the recommended measures.",
  },
  {
    title: "We Quote And Schedule The Installation",
    body: "A clear, property-specific quotation for the install work.",
  },
  {
    title: "We Install To Standard",
    body: "Completed installation with documentation on completion.",
  },
] as const;

export const GRANTS_MEASURES: {
  slug: string;
  category: ServiceCategory | "renewables";
}[] = [
  { slug: "loft-insulation", category: "insulation" },
  { slug: "cavity-wall-insulation", category: "insulation" },
  { slug: "internal-wall-insulation", category: "insulation" },
  { slug: "ventilation-and-extraction", category: "structural" },
  { slug: "boilers-and-heating", category: "heating" },
  { slug: "heating-controls", category: "heating" },
  { slug: "air-source-heat-pumps", category: "heating" },
  { slug: "solar-pv", category: "renewables" },
];

export const GRANTS_PROPERTY_TYPES = [
  "Detached house",
  "Semi-detached house",
  "Terraced house",
  "Bungalow",
  "Flat / maisonette",
  "Other",
] as const;

export const GRANTS_DISCLAIMER =
  "CRS Energy is an approved installer under the Green Homes Plan. Eligibility and funding are determined by the scheme and your retrofit assessment. CRS does not assess eligibility or arrange funding.";

export const GRANTS_META = {
  title: "Green Homes Plan Approved Installer | CRS Energy",
  description:
    "CRS Energy is an approved installer under the Green Homes Plan. We carry out retrofit installation work for homes that already have an assessment. We do not assess eligibility or arrange funding.",
};
